<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row>
							<v-col cols="12" class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pb-0 pt-0"> {{ $t('modules.surveys') }}</v-card-title>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="surveysTable.additionalFilters"
									:default-sort="surveysTable.defaultSort"
									:excel="true"
									:fields="surveysTable.headers"
									:header-selection-key="'surveys-headers'"
									:height="surveysTable.height"
									:total-records="surveysTable.total"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in surveysTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="redirect(props.item.planned_course_id)"
									>
										<td
											v-if="surveysTable.selectedHeaders.includes('pc_id')"
											@click="redirect(item.pc_id)"
										>
											{{ item.pc_id }}
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('course_name')"
											@click="redirect(item.pc_id)"
										>
											<b>{{ item.course_name }}</b>
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('planned_course_code')"
											@click="redirect(item.pc_id)"
										>
											<b>{{ item.planned_course_code }}</b>
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('office_name')"
											@click="redirect(item.pc_id)"
										>
											<b>{{ item.office_name }}</b>
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('creation_date')"
											@click="redirect(item.pc_id)"
										>
											{{
												item.creation_date != null
													? item.creation_date.split('-').reverse().join('.')
													: ''
											}}
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('registration')"
											@click="redirect(item.pc_id)"
										>
											{{ item.planned_course_registration }}
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('completed_surveys')"
											@click="redirect(item.pc_id)"
										>
											{{ item.completed_surveys }}
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('completed_survey_percentage')"
											@click="redirect(item.pc_id)"
										>
											{{
												item.completed_survey_percentage == null
													? 0
													: parseFloat(item.completed_survey_percentage).toFixed(2) + '%'
											}}
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('average_course_rating')"
											@click="redirect(item.pc_id)"
										>
											{{ parseFloat(item.average_course_rating).toFixed(2) }}
										</td>
										<td
											v-if="surveysTable.selectedHeaders.includes('ratings_amount')"
											@click="redirect(item.pc_id)"
										>
											{{ item.ratings_amount }}
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Surveys',
	components: { TheTable },
	data: function () {
		return {
			surveysTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.id'),
						width: '100px',
						value: 'pc_id',
						type: 'string',
						allowFilter: true,
					},
					{
						text: this.$t('fields.course'),
						value: 'course_name',
						type: 'dropdown|courses',
						allowFilter: true,
					},
					{
						text: this.$t('fields.plannedCourse'),
						value: 'planned_course_code',
						type: 'dropdown|planned-courses-codes',
						allowFilter: true,
					},
					{
						text: this.$t('fields.office'),
						value: 'office_name',
						type: 'dropdown|offices',
						allowFilter: true,
					},
					{
						text: this.$t('fields.date'),
						value: 'creation_date',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.registration'),
						value: 'registration',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.completedSurveys'),
						value: 'completed_surveys',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.completedSurveyPercentage'),
						value: 'completed_survey_percentage',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.averageGrade'),
						value: 'average_course_rating',
						type: '',
						allowFilter: true,
					},
					{
						text: this.$t('fields.ratingsExplainationAmount'),
						value: 'ratings_amount',
						type: '',
						allowFilter: true,
					},
				],
				additionalFilters: [
					{
						text: this.$t('fields.date'),
						value: 'creation_date',
						type: 'date_range',
					},
					{
						text: this.$t('fields.registration'),
						value: 'registration',
						type: 'number_range',
					},
					{
						text: this.$t('fields.completedSurveys'),
						value: 'completed_surveys',
						type: 'number_range',
					},
					{
						text: this.$t('fields.completedSurveyPercentage'),
						value: 'completed_survey_percentage',
						type: 'number_range',
					},
					{
						text: this.$t('fields.averageGrade'),
						value: 'average_course_rating',
						type: 'number_range',
					},
					{
						text: this.$t('fields.ratingsExplainationAmount'),
						value: 'ratings_amount',
						type: 'number_range',
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'creation_date',
					descending: true,
				},
			},
			showModal: false,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.surveysTable.selectedHeaders = headers;
		},
		redirect(id) {
			this.$router.push('/planned-courses/' + id);
		},
		reloadData(request) {
			this.surveysTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'surveys',
				request,
				(data, success) => {
					if (success) {
						vm.surveysTable.items = data.items;
						vm.surveysTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.surveysTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'surveys',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/surveys', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.surveysTable.height = window.innerHeight - 235 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.surveys'), href: '/#/surveys', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
